module.exports = __webpack_public_path__ + "static/media/note-call-white.b5804f18.svg";